export const APP_NAME = 'sales-checkin';
export const SALESCHECKIN_ROOT_ROUTE = '';
